// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"TaskRow_thumbnail__MRf_B"};